import _inheritsLoose from "@babel/runtime/helpers/inheritsLoose";
import React, { Component } from "react";
import { bool, func, object, string } from "prop-types";
import moment from "moment";
import DayPickerInput from "@icg360/ui-toolkit/react-day-picker/DayPickerInput";
import { DATE_FORMAT_UI, DATE_FORMAT_ISO8601 } from "../../constants";
import { Button } from "@icg360/ui-toolkit";
import { Icon } from "@icg360/design-system";
import { formatDate, parseDate } from "@icg360/ui-toolkit/react-day-picker/moment";

var InputDate = /*#__PURE__*/function (_Component) {
  _inheritsLoose(InputDate, _Component);

  /**
   * How we do dates:
   *
   * If there's already a date value when initializing, it needs to be in
   * ISO8601 format (moment needs an expected format).
   *
   * We store the selectedDate as a Date object and anytime it gets updated
   * we push it to the `onChange` prop.
   */
  function InputDate(props) {
    var _this;

    _this = _Component.call(this, props) || this;

    _this.handleChange = function (selectedDate) {
      _this.updateDate(selectedDate);
    };

    _this.handleBlur = function (e) {
      // We set a *slight* delay on firing the blur, so we don't get a flicker
      // of showing the error message
      var onBlur = _this.props.onBlur;

      if (onBlur) {
        setTimeout(function () {
          return onBlur(e);
        }, 300);
      }

      if (e.target.value) {
        var selectedDate = _this.state.selectedDate; // The actual date of the <input> should be DATE_FORMAT_UI, so we check
        // to see if the date in the state matches that. If it doesn't, consider
        // the currently entered date invalid and clear it from the <input>

        var momentInUi = e.target.value;
        var momentInState = moment(selectedDate).format(DATE_FORMAT_UI);

        if (momentInUi !== momentInState) {
          _this.updateDate("");
        }
      }
    };

    _this.handleCalendarClick = function () {
      var id = _this.props.id;
      document.getElementById(id).focus();
    };

    _this.handleTodayClick = function () {
      var date = new Date();

      _this.updateDate(date);
    };

    _this.handle30DayClick = function () {
      var date = new Date();
      date.setDate(date.getDate() + 30);

      _this.updateDate(date);
    };

    _this.updateDate = function (date) {
      var onChange = _this.props.onChange;
      var selectedDate = _this.state.selectedDate; // Store the selected date in local state and bubble it up

      if (!selectedDate && !date) {
        return;
      }

      _this.setState({
        selectedDate: date
      });

      onChange(date);
    };

    var value = props.value;
    _this.state = {
      selectedDate: value ? moment(value, DATE_FORMAT_ISO8601).toDate() : ""
    };
    return _this;
  }
  /**
   * Handle when the date changes. If `selectedDate` is undefined, that means
   * the current date in the input isn't valid. So we don't update any state
   * (as the user may be typing something)
   *
   * @param {Date} selectedDate
   */


  var _proto = InputDate.prototype;

  _proto.render = function render() {
    var _this$props = this.props,
        dayPickerProps = _this$props.dayPickerProps,
        id = _this$props.id,
        isReadOnly = _this$props.isReadOnly,
        showEffectiveDateButtons = _this$props.showEffectiveDateButtons;
    var selectedDate = this.state.selectedDate;
    return /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("div", {
      className: "input-group"
    }, /*#__PURE__*/React.createElement("span", {
      className: "input-group-addon",
      onClick: this.handleCalendarClick
    }, /*#__PURE__*/React.createElement(Icon, {
      name: "Calendar",
      size: "sm"
    })), /*#__PURE__*/React.createElement(DayPickerInput, {
      value: selectedDate,
      format: DATE_FORMAT_UI,
      formatDate: formatDate,
      parseDate: parseDate,
      onDayChange: this.handleChange,
      placeholder: DATE_FORMAT_UI.toLowerCase(),
      inputProps: {
        autoComplete: "off",
        id: id,
        disabled: isReadOnly,
        name: id,
        className: "form-control",
        onBlur: this.handleBlur
      },
      dayPickerProps: dayPickerProps
    }), /*#__PURE__*/React.createElement("style", {
      dangerouslySetInnerHTML: {
        __html: "\n                .DayPickerInput {\n                  display: block;\n                }\n                .DayPickerInput-OverlayWrapper {\n                  position: relative;\n                  top: 34px;\n                  z-index: 3;\n                }\n                .DayPickerInput .form-control {\n                  border-top-right-radius: 4px !important;\n                  border-bottom-right-radius: 4px !important;\n                }\n                Button {\n                  margin: 5px 5px 0 0;\n                }\n              "
      }
    })), showEffectiveDateButtons && /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(Button, {
      onClick: this.handleTodayClick
    }, "Today"), /*#__PURE__*/React.createElement(Button, {
      onClick: this.handle30DayClick
    }, "+30 days from today")));
  };

  return InputDate;
}(Component);

InputDate.propTypes = {
  // If it exsists, it should be ISO8601 format (yyyy-mm-dd)
  value: function value(props, propName, componentName) {
    if (props[propName] && !/\d{4}-\d{2}-\d{2}/.test(props[propName])) {
      return new Error("Invalid prop `" + propName + "` supplied to `" + componentName + "`. " + "Expected format: `YYYY-MM-DD`. " + ("Received value: `" + props[propName] + "`. ") + "Validation failed.");
    }
  },
  id: string.isRequired,
  isReadOnly: bool.isRequired,
  onBlur: func,
  onChange: func.isRequired,
  showEffectiveDateButtons: bool,
  // Additional props for the day picker (see 3rd party docs)
  dayPickerProps: object
};
InputDate.defaultProps = {
  isReadOnly: false
};
export { InputDate as default };